<template>
    <div>
        <router-view></router-view>
    </div>
</template>
